module.exports = __webpack_public_path__ + "img/logo-circles-only.3220f4e1.svg";